<mc-notification-card [severity]="severity">
  <button
    (click)="onClickAction($event, notificationStatus.READ)"
    aria-label="read notification"
    class="flex container"
    role="contentinfo"
  >
    <div #notificationContent class="notification-content" [ngClass]="{collapsed: !expanded}">
      <span class="grow">
        <ng-content select="[content]"></ng-content>
      </span>
      @if (expanded) {
        <div>
          <ng-content></ng-content>
        </div>
      }
    </div>
    <div class="notification-icon-wrapper" [ngClass]="{expanded: expanded}">
      <button
        (click)="onExpandAction($event)"
        [tabindex]="showExpandIcon ? 0 : -1"
        aria-label="collapse/expand notification"
        class="notification-expand"
      >
        <mat-icon class="expand-icon">expand_more</mat-icon>
      </button>
      <button
        class="notification-dismiss"
        (click)="onClickAction($event, notificationStatus.DISMISS)"
        aria-label="dismiss notification"
      >
        @if (notificationDismiss) {
          <mat-icon svgIcon="bell_crossed"></mat-icon>
        } @else {
          <mat-icon svgIcon="bell" aria-label="Dismiss notification"></mat-icon>
        }
      </button>
    </div>
    @if (notificationNotReaded) {
      <div class="notification-unread-dot"></div>
    }
  </button>
</mc-notification-card>
